/*
 * @Author: zhujuan
 * @Date: 2022-03-15 09:49:35
 * @LastEditors: qingqi qingqi@winning.com.cn
 * @LastEditTime: 2022-05-30 11:00:39
 * @Description:
 * @FilePath: /aers-ui-new/src/store/modules/theme.js
 */
// 设置文件
const themeList = [
  {
    title: 'winex主题蓝',
    name: 'winning-winex',
    '--COLOR-NORMAL': '#2D5AFA',
    '--COLOR-NORMAL-RGB': '45, 90, 250',
    '--COLOR-HOVER': '#5175f4',
    '--COLOR-PRESS': '#1d39c4',
    '--COLOR-NORMAL-BG': 'rgba(	81, 117, 244,.5)',
    '--COLOR-ACTIVE-BG': '#f3f5ff'
  },

  {
    title: '复星禅医紫',
    name: 'winning',
    '--COLOR-NORMAL': '#9E7EEE',
    '--COLOR-NORMAL-RGB': '158, 126, 238',
    '--COLOR-HOVER': '#B096F0',
    '--COLOR-PRESS': '#5630B4',
    '--COLOR-NORMAL-BG': 'rgba(176, 150, 240,.5)',
    '--COLOR-ACTIVE-BG': '#F8F5FF'
  },

  {
    title: '复星城南医院',
    name: 'winning-green',
    '--COLOR-NORMAL': '#13892F',
    '--COLOR-NORMAL-RGB': '19, 137, 47',
    '--COLOR-HOVER': '#82C48B',
    '--COLOR-PRESS': '#04661C',
    '--COLOR-NORMAL-BG': 'rgba(	130, 196, 139,.5)',
    '--COLOR-ACTIVE-BG': '#F4FFF8'
  }
]

export default {
  state: {
    // 现在激活的主题 这应该是一个名字 不是对象
    activeName: '',
    activeIndex: 0
  },
  getters: {
    /**
     * @description 返回当前的主题信息 不是一个名字 而是当前激活主题的所有数据
     * @param {Object} state vuex state
     */
    activeSetting(state) {
      return themeList.find((theme) => theme.name === state.activeName)
    }
  },
  actions: {
    /**
     * @description 激活一个主题
     * @param {Object} state vuex state
     * @param {String} themeValue 需要激活的主题名称
     */
    setTheme({ state, commit, dispatch }, themeName) {
      return new Promise(async (resolve) => {
        // 检查这个主题在主题列表里是否存在

        const activeThemeIndex = themeList.findIndex(
          (e) => e.name === themeName
        )
        state.activeName =
          activeThemeIndex > -1
            ? themeList[activeThemeIndex].name
            : themeList[0].name
        state.activeIndex = activeThemeIndex > -1 ? activeThemeIndex : 0
        // 将 vuex 中的主题应用到 dom
        commit('dom')
        resolve()
      })
    }
  },
  mutations: {
    /**
     * @description 将 vuex 中的主题应用到 dom
     * @param {Object} state vuex state
     */
    dom(state) {
      const _THEME_VARS = [
        '--COLOR-NORMAL',
        '--COLOR-NORMAL-RGB',
        '--COLOR-HOVER',
        '--COLOR-PRESS',
        '--COLOR-NORMAL-BG',
        '--COLOR-ACTIVE-BG'
      ]
      const _THEMES = themeList[state.activeIndex]
      _THEME_VARS.forEach((key) => {
        // 在 html 节点上添加 CSS 变量
        document.documentElement.style.setProperty(key, _THEMES[key])
      })
      document.body.className = `theme-${state.activeName}`
    }
  }
}
